import { Link } from "react-router";
import { Button } from "@/components/shadcn/button";
import { INVITE_ONLY } from "@/lib/access";
import { HowItWorks } from "@/views/how-it-works";

/** Public home for logged-out visitors. */
export default function LandingView() {
  return (
    <div className="pb-4 sm:pb-8">
      <section className="px-2 pb-16 pt-14 text-center sm:pb-20 sm:pt-20">
        <div className="mx-auto max-w-3xl">
          <h1 className="font-serif text-5xl font-semibold tracking-tight text-foreground sm:text-6xl">
            Chariot
          </h1>
          <h2 className="mt-5 font-serif text-2xl font-medium tracking-tight text-foreground/90 sm:text-3xl">
            Bezpieczeństwo leku w każdym trymestrze ciąży
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg sm:leading-8">
            ChPL zwykle opisuje ciążę jako całość. Chariot pokazuje osobno, co
            wiadomo o każdym trymestrze, o karmieniu piersią oraz o płodności
            kobiet i mężczyzn. Każda informacja prowadzi do źródła, z którego
            pochodzi.
          </p>

          {INVITE_ONLY ? (
            <div className="mt-8 flex justify-center">
              <Button asChild className="h-12 min-w-[13rem] px-7 font-medium">
                <Link to="/login">Zaloguj się</Link>
              </Button>
            </div>
          ) : (
            <>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Button asChild className="h-12 min-w-[13rem] px-7 font-medium">
                  <Link to="/signup">Załóż bezpłatne konto</Link>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  className="h-12 min-w-[13rem] px-7 font-medium"
                >
                  <Link to="/login">Zaloguj się</Link>
                </Button>
              </div>
              <p className="mt-4 text-sm text-muted-foreground">
                Dla lekarzy. Przy rejestracji poprosimy o numer PWZ.
              </p>
            </>
          )}
        </div>
      </section>

      <HowItWorks />
    </div>
  );
}
